module.exports = __webpack_public_path__ + "media/src/images/step05-2c441ad1728b18384226a931db57f192.png";